export class SummaryPayServiceModel {
    public TotalStatusAll!: number;
    public TotalStatus1!: number;
    public TotalStatus2!: number;
    public TotalStatus3!: number;
    public TotalStatus4!: number;
    public TotalStatus5!: number;
}